const moduleApp={
    state: {
        loading:false  
    },
    mutations: {
        SHOW_LOADING:(state)=>{
            state.loading=true
        },
        HIDE_LOADING:(state)=>{
            state.loading=false
        }
    }
}

export default moduleApp